"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stampReceipt = void 0;
const api_1 = require("../api");
/**
 * Issuance and stamping service receives a JSON file with a defined structure (POST)
 * @param endpoint URL to request data
 * @param json JSON of type ComprobanteType from EsquemaV4
 * @param token Authentication bearer Token
 * @returns JSON with { data, status} of type responseComprobanteV4
 */
async function stampReceipt(endpoint, json) {
    try {
        const data = await api_1.api.post(endpoint, json);
        return data.data;
    }
    catch (error) {
        if (error.response) {
            // :: The request was made and the server responded with a status code
            return {
                data: error.response.data,
                status: error.response.status,
            };
        }
        else if (error.request) {
            // :: The request was made but no response was received
            return {
                data: error.request,
                status: 404,
            };
        }
        else {
            // :: Something happened in setting up the request that triggered an Error
            return {
                data: error.message,
                status: 'ERROR',
            };
        }
    }
}
exports.stampReceipt = stampReceipt;
//# sourceMappingURL=stampReceipts.js.map